import { render, staticRenderFns } from "./WeeklyPlan.vue?vue&type=template&id=1e621477"
import script from "./WeeklyPlan.vue?vue&type=script&lang=js"
export * from "./WeeklyPlan.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports